module.exports = __webpack_public_path__ + "img/616415da7c61511e8088902aa9710f78.png";